const megabytes = 1024 * 1024
export const MAX_FILE_SIZE = 10 * megabytes
export const MAX_FILE_SIZE_TEXT = '10 MB'
